module.exports = __webpack_public_path__ + "img/1_x2.e97ccbc3.png";